import * as React from 'react';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../redux/models';
import { QualityLevelInfo } from '../redux/models/QualityState';
import { QualityActions } from '../redux/actions';
import styles from './QualitySelector.module.scss';

const formatLabel = (l: QualityLevelInfo) => {
	if (l.name) return l.name;
	if (l.height) return `${l.height}p`;
	if (l.bitrate) return `${Math.round((l.bitrate || 0) / 1000)} kbps`;
	return `Level ${l.index}`;
};

const QualitySelector: React.FC = () => {
	const dispatch = useDispatch();
	const state = useSelector((s: RootState) => s.quality);

	const onChange: React.ChangeEventHandler<HTMLSelectElement> = useCallback(
		(e) => {
			const value = e.target.value;
			if (value === 'auto') {
				dispatch(QualityActions.actionCreators.setSelection({ auto: true, currentLevel: -1 }));
			} else {
				const idx = parseInt(value, 10);
				if (!Number.isNaN(idx)) {
					dispatch(QualityActions.actionCreators.setSelection({ auto: false, currentLevel: idx }));
				}
			}
		},
		[dispatch]
	);

	// Only show if there are at least two unique variants
	const uniqueKey = (l: QualityLevelInfo) => (l.height ? `h${l.height}` : l.bitrate ? `b${l.bitrate}` : `i${l.index}`);
	const uniqueCount = new Set(state.levels.map(uniqueKey)).size;
	if (uniqueCount <= 1) return null;

	const sorted = [...state.levels].sort((a, b) => (b.height || 0) - (a.height || 0));

	if (!state.available) return null;

	return (
		<div className={styles.root}>
			<select id='qualitySelect' value={state.auto ? 'auto' : String(state.currentLevel)} onChange={onChange}>
				<option value='auto'>Auto</option>
				{sorted.map((l) => (
					<option key={l.index} value={l.index}>
						{formatLabel(l)}
					</option>
				))}
			</select>
		</div>
	);
};

export default QualitySelector;
